// extracted by mini-css-extract-plugin
module.exports = {"pcItem":"pcItem___17rpS","title":"title___2bf0H","img":"img___3G6Vc","mobileItem":"mobileItem___2nCmP","imgWrap":"imgWrap___RYZKc"};